<template>
  <transition name="expand-transition" @enter="setTransitionTargets" @leave="setTransitionTargets">
    <div
      v-if="show"
      v-bind="$attrs"
      class="expand-transition-body"
      :style="{ '--expand-transition-duration': duration }"
    >
      <slot />
    </div>
  </transition>
</template>

<script setup>
import { useCssVar } from '@vueuse/core'

const { show } = defineProps({
  show: Boolean,
  duration: {
    type: String,
    default: '250ms',
  },
})

function setTransitionTargets(el) {
  const style = window.getComputedStyle(el)
  useCssVar('--max-height', el, { initialValue: `${el.scrollHeight}px` })
  useCssVar('--padding-top', el, { initialValue: style.paddingTop })
  useCssVar('--padding-bottom', el, { initialValue: style.paddingBottom })
  useCssVar('--margin-top', el, { initialValue: style.marginTop })
  useCssVar('--margin-bottom', el, { initialValue: style.marginBottom })
}
</script>

<style lang="scss">
.expand-transition {
  &-body {
    box-sizing: content-box;
  }

  &-enter-active,
  &-leave-active {
    transition-property: max-height, opacity, padding-top, padding-bottom, margin-top, margin-bottom;
    transition-timing-function: linear;
    transition-duration: var(--expand-transition-duration);
    overflow-y: hidden;
  }

  &-enter-to,
  &-leave-from {
    opacity: 1;
    max-height: var(--max-height);
    padding-top: var(--padding-top);
    padding-bottom: var(--padding-bottom);
    margin-top: var(--margin-top);
    margin-bottom: var(--margin-bottom);
  }

  &-enter-from,
  &-leave-to {
    opacity: 0 !important;
    max-height: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>
